export enum CodeTypes {
    AppointmentType = 'AppointmentType',
    WorkTicketStatus = 'WorkTicketStatus',
    WorkTicketSubStatus = 'WorkTicketSubStatus'
}